import Link from "next/link";

interface TailwindButtonProps {
  buttonText: string;
  buttonTextTailwindStyle: string;
  buttonBGColor: string;
  buttonURL?: string;
  buttonBorderColor: string;
  buttonHeight: string;
  buttonWidth: string;
  onClick?: () => void;
}

const TailwindButton = ({
  buttonText,
  buttonTextTailwindStyle,
  buttonBGColor,
  buttonURL,
  buttonBorderColor,
  buttonHeight,
  buttonWidth,
  onClick,
}: TailwindButtonProps) => {
  const shineAnimation = `
        flex
        bg-[linear-gradient(45deg,rgba(117,81,203,0)_25%,rgba(255,255,255,.2)_50%,rgba(117,81,203,0)_75%,rgba(117,81,203,0)_100%)] 
        bg-[length:250%_250%,100%_100%] 
        bg-[position:-100%_0,0_0] 
        bg-no-repeat
        hover:bg-[position:200%_0,0_0] hover:duration-[1500ms]
    `;

  const growAnimation = `
       hover:-translate-y-0.5 duration-[250ms]
    `;

  const buttonStyling = `
        rounded-b-lg 
        border-b-[6px] border-t-[1px] border-s-[1px] border-e-[1px] 
        ${buttonBorderColor}
        ${buttonBGColor}
        ${buttonWidth}
        ${buttonHeight}
        box-border 
        rounded 
        text-white
        items-center
        justify-center
    `;

  return (
    <div className={growAnimation}>
      {buttonURL ? (
        <Link
          href={buttonURL}
          style={{ textDecoration: "none" }}
          className={shineAnimation + " " + buttonStyling + " "}
        >
          <p className={buttonTextTailwindStyle}>{buttonText}</p>
        </Link>
      ) : (
        <button
          onClick={onClick}
          style={{ textDecoration: "none" }}
          className={shineAnimation + " " + buttonStyling + " "}
        >
          <p className={buttonTextTailwindStyle}>{buttonText}</p>
        </button>
      )}
    </div>
  );
};

export default TailwindButton;
